(function updateCurrentYear() {
  document.querySelector('#current-year').textContent =
    new Date().getFullYear();
})();
